module.exports = __webpack_public_path__ + "img/snowflake-satek-2.140a43c3.png";